module.exports = __webpack_public_path__ + "media/images/sandbox/knuckles-ca85a2c98c663f7cf2d47d27e5b3010a.png";